import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useProductMapping } from "./store";

const INITIAL_FORM = {
  address1: "",
  address2: "",
  zip: "",
  city: "",
  province: "",
  country: "India",
  country_code: "IN",
};

function AddressFormModal({ show, onHide, onSave, editAddress }) {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const { getStateCityFromPincode } = useProductMapping();

  useEffect(() => {
    if (editAddress) {
      setFormData({
        address1: editAddress.address1 || "",
        address2: editAddress.address2 || "",
        zip: editAddress.zip || "",
        city: editAddress.city || "",
        province: editAddress.province || "",
        country: editAddress.country || "India",
        country_code: editAddress.country_code || "IN",
      });
    } else {
      setFormData(INITIAL_FORM);
    }
  }, [editAddress, show]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (field === "zip" && value.length === 6) {
      fetchCityState(value);
    }
  };

  const fetchCityState = async (pincode) => {
    const data = await getStateCityFromPincode(pincode);
    if (data) {
      setFormData((prev) => ({
        ...prev,
        city: data.city || prev.city,
        province: data.state || prev.province,
        country: "India",
        country_code: "IN",
      }));
    }
  };

  const isValid =
    formData.address1 &&
    formData.address2 &&
    formData.zip &&
    formData.zip.length === 6 &&
    formData.city &&
    formData.province &&
    formData.country;

  const handleSubmit = () => {
    if (!isValid) return;
    onSave(formData);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>
          {editAddress ? "Edit Address" : "Add New Address"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-2 g-2">
          <Form.Group as={Col} xs={6}>
            <Form.Label>PIN Code</Form.Label>
            <Form.Control
              type="text"
              value={formData.zip}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                if (val.length <= 6) handleChange("zip", val);
              }}
              isInvalid={formData.zip && formData.zip.length !== 6}
              placeholder="6-digit PIN"
            />
            <Form.Control.Feedback type="invalid">
              PIN code must be 6 digits
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} xs={6}>
            <Form.Label>Province/State</Form.Label>
            <Form.Control
              type="text"
              value={formData.province}
              disabled={!!formData.province}
              onChange={(e) => handleChange("province", e.target.value)}
            />
          </Form.Group>
        </Row>
        <Row className="mb-2 g-2">
          <Form.Group as={Col} xs={6}>
            <Form.Label>Country</Form.Label>
            <Form.Control
              type="text"
              value={formData.country}
              disabled={!!formData.country}
              onChange={(e) => handleChange("country", e.target.value)}
            />
          </Form.Group>
          <Form.Group as={Col} xs={6}>
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              value={formData.city}
              disabled={!!formData.city}
              onChange={(e) => handleChange("city", e.target.value)}
            />
          </Form.Group>
        </Row>
        <Form.Group className="mb-2">
          <Form.Label>Address Line 1 <span style={{ color: "red" }}>*</span></Form.Label>
          <Form.Control
            type="text"
            value={formData.address1}
            onChange={(e) => handleChange("address1", e.target.value)}
            placeholder="House/Building, Area"
            isInvalid={!formData.address1}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Address Line 2 <span style={{ color: "red" }}>*</span></Form.Label>
          <Form.Control
            type="text"
            value={formData.address2}
            onChange={(e) => handleChange("address2", e.target.value)}
            placeholder="Landmark, Street"
            isInvalid={!formData.address2}
          />
          <Form.Control.Feedback type="invalid">
            Address Line 2 is required
          </Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={!isValid}>
          {editAddress ? "Update" : "Save"} Address
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddressFormModal;
